import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  width: "17",
  height: "16",
  viewBox: "0 0 17 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.85034 14C12.1641 14 14.8503 11.3137 14.8503 8C14.8503 4.68629 12.1641 2 8.85034 2C5.53663 2 2.85034 4.68629 2.85034 8C2.85034 11.3137 5.53663 14 8.85034 14ZM9.51701 5.33333C9.51701 4.96514 9.21853 4.66667 8.85034 4.66667C8.48215 4.66667 8.18368 4.96514 8.18368 5.33333V8.33333C8.18368 8.70152 8.48215 9 8.85034 9H11.517C11.8852 9 12.1837 8.70152 12.1837 8.33333C12.1837 7.96514 11.8852 7.66667 11.517 7.66667H9.51701V5.33333Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}